export default __webpack_public_path__ + "static/media/caddie.613f79b0.svg";